import { notifyParent } from 'mailup-react-helpers'
import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Panel,
  SPACING_24,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_LIGHT,
  TEXT_VARIANT_SMALL,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import ImgOpens from 'mailup-web-components/bundle/img/icons/statistica-aperture.svg'
import ImgClicks from 'mailup-web-components/bundle/img/icons/statistica-clic.svg'
import ImgSent from 'mailup-web-components/bundle/img/icons/statistica-invii.svg'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { workflowEmailStatsState } from 'Pages/Workflow/recoil/state/stats'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { useHistory } from 'react-router-dom'
import { StatBigNumber, StatsInfo } from './BoxStatistics.styles'

const intFormat = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}

const pctFormat = {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
}

const strongFormatter = (chunks) => <strong>{chunks}</strong>

const BoxEmailStatistics = () => {
  const intl = useIntl()
  const history = useHistory()
  const { Id, IdAggregateReport } = useRecoilValue(workflowDetails)

  const { show, msgCount, idMessage, hasStats, sent, pctOpens, pctClicks } =
    useRecoilValue(workflowEmailStatsState)

  const handleAggregateReportStatsClick = () => {
    notifyParent('redirectMainFrame', [
      `statistics_app_redirector.aspx?r=/stats/insight/aggregate/view/${IdAggregateReport}`
    ])
  }

  const handleMessageStatsClick = () => {
    notifyParent('redirectMainFrame', [
      `statistics_app_redirector.aspx?r=/stats/sendouts/sending/mode/messages/0/${idMessage}`
    ])
  }

  const handleStatsClick = () => {
    history.push(`/automation/workflows/statistics/${Id}`)
  }

  return show ? (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.StatisticsEmailTitle'
          })}
        </Title>
        <SpacingVertical variant={SPACING_24} />

        <Flex justifyContent='space-between'>
          <Flex alignItems='center'>
            <img src={ImgSent} />
            <FlexItem margin='0 0 0 8px'>
              <StatBigNumber>
                {intl.formatNumber(sent, intFormat)}
              </StatBigNumber>
              <br />
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({ id: 'Load.MailupCommon.Sent' })}
              </Text>
            </FlexItem>
          </Flex>
          <Flex alignItems='center'>
            <img src={ImgOpens} />
            <FlexItem margin='0 0 0 8px'>
              <StatBigNumber>
                {intl.formatNumber(pctOpens, pctFormat)}
              </StatBigNumber>
              <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
                {' '}
                %
              </Text>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({ id: 'Load.Statistics.PercOpen' })}
              </Text>
            </FlexItem>
          </Flex>
          <Flex alignItems='center'>
            <img src={ImgClicks} />
            <FlexItem margin='0 0 0 8px'>
              <StatBigNumber>
                {intl.formatNumber(pctClicks, pctFormat)}
              </StatBigNumber>
              <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
                {' '}
                %
              </Text>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({ id: 'Load.Statistics.PercClick' })}
              </Text>
            </FlexItem>
          </Flex>
          <StatsInfo
            flex='0 0 25%'
            padding='0 16px'
            flexDirection='column'
            rowGap='4px'
          >
            <Text variant={TEXT_VARIANT_SMALL}>
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.StatisticInfoGeneric'
              })}
            </Text>
            {msgCount > 1 && !(IdAggregateReport > 0 && hasStats) && (
              <Text variant={TEXT_VARIANT_SMALL}>
                {intl.formatMessage(
                  {
                    id: 'Load.AutomationWorkflow.AggregateReportInfo'
                  },
                  { strong: strongFormatter }
                )}
              </Text>
            )}
            {msgCount > 1 && IdAggregateReport > 0 && hasStats && (
              <Text variant={TEXT_VARIANT_SMALL}>
                {intl.formatMessage(
                  {
                    id: 'Load.AutomationWorkflow.AggregateReportLinkIntl'
                  },
                  {
                    strong: strongFormatter,
                    link: (chunks) => (
                      <Link
                        variant={LINK_VARIANT_HIGHLIGHT}
                        onClick={handleAggregateReportStatsClick}
                      >
                        {chunks}
                      </Link>
                    )
                  }
                )}
              </Text>
            )}
            {msgCount === 1 && !(sent > 0 && hasStats) && (
              <Text variant={TEXT_VARIANT_SMALL}>
                {intl.formatMessage(
                  {
                    id: 'Load.AutomationWorkflow.AggregateReportInfo'
                  },
                  { strong: strongFormatter }
                )}
              </Text>
            )}
            {msgCount === 1 && sent > 0 && hasStats && (
              <Text variant={TEXT_VARIANT_SMALL}>
                {intl.formatMessage(
                  { id: 'Load.AutomationWorkflow.SummaryReportLinkIntl' },
                  {
                    strong: strongFormatter,
                    link: (chunks) => (
                      <Link
                        variant={LINK_VARIANT_HIGHLIGHT}
                        onClick={handleMessageStatsClick}
                      >
                        {chunks}
                      </Link>
                    )
                  }
                )}
              </Text>
            )}
          </StatsInfo>
        </Flex>
        <SpacingVertical variant={SPACING_8} />
        <Flex justifyContent='flex-start'>
          <Button kind={BUTTON_VARIANT_SECONDARY} onClick={handleStatsClick}>
            {intl.formatMessage({ id: 'Load.Statistics.StatWorkflow' })}
          </Button>
        </Flex>
      </Panel>
    </>
  ) : null
}

export default BoxEmailStatistics
